import { render, staticRenderFns } from "./DashboardAgents.vue?vue&type=template&id=01363621&"
import script from "./DashboardAgents.vue?vue&type=script&lang=js&"
export * from "./DashboardAgents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports